// external dependencies
import React from 'react'
import { bool, func, number, string } from 'prop-types'

MapMarkerIcon.propTypes = {
	fill: string,
	height: number,
	innerFill: string,
	isExpanded: bool,
	onClick: func,
	width: number,
	zIndex: string,
}

/**
 * MapMarkerIcon
 *
 * Default SVG component for a generic map marker. Can be resized to 1.3 it's normal size if the incoming
 * "isExpanded" prop is set to TRUE. Also the 2 colors being used are flexible and can be changed via props.
 */
export function MapMarkerIcon({
	fill = '#E7040F',
	height = 35,
	innerFill = '#FF725C',
	isExpanded = false,
	onClick,
	width = 24,
	zIndex = 'auto',
}) {
	const scalar = isExpanded ? 1.3 : 1

	const wrapperStyles = {
		cursor: 'pointer',
		display: 'inline-block',
		height,
		left: width / -2,
		position: 'absolute',
		top: height * -1,
		transform: `scale(${scalar}, ${scalar})`,
		transformOrigin: `${width / 2}px ${height}px`,
		transition: 'transform 0.5s',
		verticalAlign: 'middle',
		width,
		zIndex,
	}

	return (
		<div onClick={onClick} style={wrapperStyles}>
			<svg width="100%" height="100%" viewBox="0 0 363.91 485.21">
				<path
					d="M242.8,0c-100.48,0-182,81.47-182,182A181.13,181.13,0,0,0,97.16,291L242.8,485.21,388.45,291A181.11,181.11,0,0,0,424.76,182C424.76,81.47,343.29,0,242.8,0Zm0,303.26A121.3,121.3,0,1,1,364.1,182,121.31,121.31,0,0,1,242.8,303.26Z"
					transform="translate(-60.85)"
					style={{ fill }}
				/>
				<circle cx="181.96" cy="182" r="121" style={{ fill: innerFill }} />
			</svg>
		</div>
	)
}
